import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer-area pt-100 pb-70 bg-primary">
      <div className="container">
        <div className="row">
          {/* Company Info */}
          <div className="col-lg-3 col-md-6 col-sm-6 col-12">
            <div className="footer-widget">
              <div className="navbar-brand">
                <Link to="/" onClick={scrollToTop}>
                  <img src="/assets/img/logo2.webp" className="footer-logo" alt="Desale Patil Logo" />
                </Link>
              </div>
              <p className="footer-description">
                We build homes for you and your families for generations to enjoy and live happily.
              </p>
              <div className="social-link">
                <a 
                  href="https://www.facebook.com/profile.php?id=100041233227111" 
                  target="_blank" 
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a 
                  href="https://twitter.com" 
                  target="_blank" 
                  rel="noreferrer"
                  aria-label="Twitter"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a 
                  href="https://linkedin.com" 
                  target="_blank" 
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-6 col-sm-6 col-6">
            <div className="footer-widget">
              <h3>Quick Links</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/" onClick={scrollToTop}>
                    <i className="flaticon-play-button"></i> Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" onClick={scrollToTop}>
                    <i className="flaticon-play-button"></i> About Us
                  </Link>
                </li>
                <li>
                  <Link to="/projects" onClick={scrollToTop}>
                    <i className="flaticon-play-button"></i> Our Projects
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={scrollToTop}>
                    <i className="flaticon-play-button"></i> Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Our Services */}
          <div className="col-lg-3 col-md-6 col-sm-6 col-6">
            <div className="footer-widget">
              <h3>Our Services</h3>
              <ul className="footer-links">
                <li>
                  <Link to="/projects" onClick={scrollToTop}>
                    <i className="flaticon-play-button"></i> Building Construction
                  </Link>
                </li>
                <li>
                  <Link to="/projects" onClick={scrollToTop}>
                    <i className="flaticon-play-button"></i> Steel Plant Construction
                  </Link>
                </li>
                <li>
                  <Link to="/projects" onClick={scrollToTop}>
                    <i className="flaticon-play-button"></i> Gabion Wall Construction
                  </Link>
                </li>
                <li>
                  <Link to="/projects" onClick={scrollToTop}>
                    <i className="flaticon-play-button"></i> Painting & Tiling
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6 col-sm-12 col-12">
            <div className="footer-widget">
              <h3>Contact Info</h3>
              <ul className="footer-contact-list">
                <li>
                  <strong>Phone:</strong>
                  <a href="tel:+919823020019">
                    <i className="fas fa-phone-alt"></i> +91 9823020019
                  </a>
                </li>
                <li>
                  <strong>Email:</strong>
                  <a href="mailto:info@desalepatil.in">
                    <i className="fas fa-envelope"></i> info@desalepatil.in
                  </a>
                </li>
                <li>
                  <strong>Open Hours:</strong>
                  <span>
                    <i className="fas fa-clock"></i> Mon-Fri: 8 am – 7 pm
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Area */}
      <div className="copyright-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 text-center text-md-start">
              <p>
                <i className="far fa-copyright"></i> Copyright © {new Date().getFullYear()} <strong>Desale Patil</strong>. All Rights Reserved.
              </p>
            </div>
            <div className="col-lg-6 col-md-6">
              <ul>
                <li>
                  <Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms" onClick={scrollToTop}>Terms & Conditions</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button 
        className="scroll-to-top" 
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    </footer>
  );
};

export default Footer;
